module.exports = __webpack_public_path__ + "img/yishi8.132afa8e.jpg";